import React from 'react';
import Appbar from 'components/appbar/Appbar';
import PageHeader from 'components/page-header/PageHeader';
import { Icon, styled, Typography } from '@mui/material';
import { ChevronRightOutlined, MasksOutlined } from '@mui/icons-material';
import history from 'services/history';

const Container = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  alignItems: 'center',
}));

const Card = styled('div')(({ theme }) => ({
  alignItems: 'center',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  maxWidth: 400,
  height: 150,
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
  cursor: 'pointer',
  '& > span': {
    transition: 'all 0.3s ease-in-out',
    flex: 0.2,
    background: '#eeeeee',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& > .icon': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: 60,
    flex: 0.3,
    '& > svg': {
      fontSize: 38,
    },
  },
  '& > .arrow': {
    opacity: 0.6,
  },
  '&:hover': {
    boxShadow: theme.shadows[4],
    '& > .icon': {
      transform: 'scale(1.1)',
    },
    '& > .arrow': {
      opacity: 1,
    },
  },
}));

const CardContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flex: 1,
  '& > .description': {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
}));

const Reports: React.FC = () => {
  return (
    <>
      <Appbar title="Relatórios" />
      <PageHeader
        title="Relatórios"
        description="Selecione o relatório que deseja visualizar para obter insights estratégicos."
      />

      <Container>
        <Card onClick={() => history.push('/reports/guides')}>
          <Icon className="icon" fontSize="large">
            <MasksOutlined />
          </Icon>
          <CardContent>
            <Typography variant="body2" flex={1} align="left" fontSize={18} color="primary" fontWeight={500}>
              Consultas médicas
            </Typography>
            <Typography className="description" variant="body2" color="textSecondary">
              Análise detalhada de atendimentos e faturamento
            </Typography>
          </CardContent>
          <Icon className="arrow" fontSize="large">
            <ChevronRightOutlined />
          </Icon>
        </Card>

        <Card onClick={() => history.push('/reports/surgeries')}>
          <Icon className="icon" fontSize="large">
            <MasksOutlined />
          </Icon>
          <CardContent>
            <Typography variant="body2" flex={1} align="left" fontSize={18} color="primary" fontWeight={500}>
              Orçamentos cirúrgicos
            </Typography>
            <Typography className="description" variant="body2" color="textSecondary">
              Gestão de propostas, honorários e custos hospitalares
            </Typography>
          </CardContent>
          <Icon className="arrow" fontSize="large">
            <ChevronRightOutlined />
          </Icon>
        </Card>
      </Container>
    </>
  );
};

export default Reports;
